import { getSwiperInstance } from '@/helpers/swiperInstance';
import localStorageRepositories from "@/plugins/localStorageRepositories";
import storeeelFingerIcon from '@/assets/images/storeeelSwipeicn.png';

export const introSquareSlideAnimation = () => {
  const campaignId = window.storeeelItems?.id;

  const storageKey = `storeeel_introAnimationShown_${campaignId}`;
  const alreadyShown = localStorageRepositories.get('introAnimation')?.get?.(campaignId) ?? (localStorage.getItem(storageKey) === 'true');

  if (alreadyShown) return;

  // Insert scroll cue finger icon
  const cueContainer = document.createElement('div');
  cueContainer.className = 'scroll-cue';
  const finger = document.createElement('img');
  finger.src = storeeelFingerIcon;
  finger.alt = 'スクロール指示';
  finger.className = 'finger-icon';
  cueContainer.appendChild(finger);
  document.body.appendChild(cueContainer);

function startFingerAnimation() {
  let count = 0;
  cueContainer.style.display = 'block';

  const animate = () => {
    requestAnimationFrame(() => {
      finger.style.transition = 'transform 0.65s ease-in-out, opacity 0.65s ease-in-out';
      finger.style.opacity = '1';
      finger.style.transform = 'translateY(-90px) rotate(10deg)';
    });

    setTimeout(() => {
      finger.style.transform = 'translateY(-20px) rotate(10deg)';
    }, 650);

    setTimeout(() => {
      count++;
      if (count < 2) {
        animate();
      } else {
        finger.style.opacity = '0';
        setTimeout(() => {
          cueContainer.style.display = 'none';
        }, 500);
      }
    }, 1600);
  };

  animate();
}

  const styleTag = document.createElement('style');
  styleTag.textContent = `
    @keyframes arrowBounce {
      0%    { transform: translate3d(0px, 0px, 0px); opacity: 0; }
      10%   { opacity: 1; }
      20%   { transform: translate3d(0px, 24px, 0px); opacity: 1; }
      40%   { transform: translate3d(0px, 0px, 0px); opacity: 1; }
      60%   { transform: translate3d(0px, 24px, 0px); opacity: 1; }
      80%   { transform: translate3d(0px, 0px, 0px); opacity: 1; }
      90%   { opacity: 1; }
      100%  { transform: translate3d(0px, 0px, 0px); opacity: 0; }
    }
  `;
  document.head.appendChild(styleTag);

  setTimeout(() => {
    const slideWrapper = document.querySelector('.swiper-slide-active .slide-media-wrapper');
    if (slideWrapper) {
      slideWrapper.style.position = 'relative';
      const cue = document.createElement('div');
      cue.className = 'swipe-cue';
      cue.textContent = '↓';
      slideWrapper.appendChild(cue);
      slideWrapper.classList.add('drag-cue');

      const wrapper = document.querySelector('.swiper-wrapper');
      const swiper = getSwiperInstance();
      if (wrapper && swiper) {
        const originalTransition = wrapper.style.transition;
        const originalTranslate = swiper.getTranslate();
        const peekDistance = 50;
        const lastIndex = swiper.slides.length - 1;
        const offset = swiper.activeIndex < lastIndex ? -peekDistance : peekDistance;
        wrapper.style.transition = 'transform 0.5s ease';


        setTimeout(() => {
          startFingerAnimation();
        }, 350);
          setTimeout(() => {
          wrapper.style.transform = `translate3d(0px, ${originalTranslate + offset}px, 0px)`;
          setTimeout(() => {
            wrapper.style.transform = `translate3d(0px, ${originalTranslate}px, 0px)`;
            setTimeout(() => {
              wrapper.style.transition = originalTransition;
            }, 450);
          }, 500);
        }, 500);
      }

      if (localStorageRepositories.get('introAnimation')?.set) {
        localStorageRepositories.get('introAnimation')?.set(campaignId);
      } else {
        localStorage.setItem(storageKey, 'true');
      }
    }
  }, 300);

  const swiper = getSwiperInstance();
  if (swiper) {
    swiper.on('slideChange', () => {
      const cue = document.querySelector('.swipe-cue');
      if (cue) cue.remove();
      const bounced = document.querySelectorAll('.slide-media-wrapper.slide-bounce');
      bounced.forEach(el => el.classList.remove('slide-bounce'));
    });
  }
};

// Inject scroll cue animation styles
const animationStyle = document.createElement('style');
animationStyle.textContent = `
  .scroll-cue {
    opaciy: 0;
    position: fixed;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100000000000;
    pointer-events: none;
  }
  .finger-icon {
    width: 100px;
    height: auto;
    transform: translateY(20px) rotate(10deg);
    opacity: 0;
    transition: transform 0.65s ease-in-out, opacity 0.65s ease-in-out;
  }
`;
document.head.appendChild(animationStyle);
